import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import TextArea from '../../../../../../common/data-entry/TextArea/TextArea';
import ModalBoxes from '../../../../../../common/feedback/ModalBoxes/ModalBoxes';
import Button from '../../../../../../common/general/Button';
import ButtonGroup from '../../../../../../common/general/ButtonGroup';
import { NSPP_PATIENT } from '../../../../../../services/i18n/namespaces';
import {
  findPreviousActiveStatusFromHistory,
  isCurrentStatusRecord
} from '../PatientStatusChangeEdit/PatientStatusChangeEditService';

import './PatientStatusRemoveModal.scss';

const PatientStatusRemoveModal = ({ modalBox, patientStatusHistory, statusToRemove, removeStatus }) => {
  const { t } = useTranslation();
  const { handleSubmit, errors, control } = useForm({
    defaultValues: { comment: '' }
  });

  const onSubmit = data => {
    removeStatus(statusToRemove.id, data.comment);
  };

  return (
    <form id="remove-status-form" onSubmit={handleSubmit(onSubmit)}>
      <ModalBoxes.Header>{t('patientStatusPage.removeStatus', { ns: NSPP_PATIENT })}</ModalBoxes.Header>
      <ModalBoxes.Body>
        <div className="change-status-confirmation">
          <span className="confirmation-text">
            <b>
              {isCurrentStatusRecord(patientStatusHistory, statusToRemove)
                ? t('patientStatusPage.removingCurrentStatusMessage', { ns: NSPP_PATIENT })
                : t('patientStatusPage.areYouSureYouWantToRemoveThisStatus', { ns: NSPP_PATIENT })}
            </b>
          </span>
          <span className="confirmation-status">
            <strike>{t(`statuses.${statusToRemove.status.name}`, { ns: NSPP_PATIENT })}</strike>
            {isCurrentStatusRecord(patientStatusHistory, statusToRemove) &&
              ` → ${t(
                `statuses.${findPreviousActiveStatusFromHistory(patientStatusHistory, statusToRemove).status.name}`,
                { ns: NSPP_PATIENT }
              )}`}
          </span>
        </div>
        <Controller
          as={TextArea}
          control={control}
          rules={{ required: true }}
          validationMessage={errors.comment ? 'Comment is required.' : undefined}
          style={{ resize: 'none' }}
          rows={1}
          clearable
          label={t('comment')}
          name="comment"
        />
      </ModalBoxes.Body>
      <ModalBoxes.Footer>
        <ButtonGroup>
          <Button priority="medium" onClick={modalBox.close}>
            {t('cancel')}
          </Button>
          <Button form="remove-status-form">{t('save')}</Button>
        </ButtonGroup>
      </ModalBoxes.Footer>
    </form>
  );
};

PatientStatusRemoveModal.className = 'patient-status-remove-modal';
PatientStatusRemoveModal.size = 'w650';

export default PatientStatusRemoveModal;
